import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { LoaderService } from '../services/loader.service';
import { S3Service } from '../services/s3.service';
import { LogoutConfirmationComponent } from './logout-confirmation/logout-confirmation.component';
import { FormService } from '../form/form.service';
import { SharedService } from "../services/shared.service";
import { DashboardService } from "../dashboard/dashboard.service";
import { ProfileService } from "../profile/profile.service";
import * as _ from 'lodash';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Constants } from "../Constants";
import { DashboardComponent } from "../dashboard/dashboard.component";
import { FileCabinetFormsService } from '../file-cabinet/file-cabinet.service';
import * as moment from 'moment-timezone'
import { ChangePasswordComponent } from '../change-password/change-password.component';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  constants = Constants;
  animal: string;
  name: string;
  userName: string;
  isLoading: boolean = false;
  location: string = "";
  organizationName: string = "";
  userLogo: string = "";
  organizationLogo: string = "";
  hoverHighlight: boolean = false;
  selectedActionType: string = "";
  actionTypes = [];
  defaultActionTypes = [];
  currentPage = "";
  subMenu = [];
  childMenu = "";
  bgColor = '#E5E5E5';
  bgTextColor = "";
  userPriveleges = [];
  windowSettingsRef: any;
  windowHomeRef: any;
  windowHelpFormRef: any;
  windowHelpFaqRef: any;
  logoSource = "../../assets/images/sort-logo.svg";
  draggingOn = "";
  organizationCode = localStorage.getItem("organizationCode")
  draggingOnCompleted = false;
  draggingOnTrash = false;
  organizagionCode: string = '';
  tutorialVideosUrl: string = '';
  helpFaq = [
    {
      name: 'TUTORIAL VIDEOS',
      content: 'Content yet to be placed'
    },
    {
      name: 'CONTACT US',
      content: 'Content yet to be placed'
    }
    // {
    //   name: 'Forms',
    //   content: 'Content yet to be placed'
    // },
    // {
    //   name: 'Lists',
    //   content: 'Content yet to be placed'
    // },
    // {
    //   name: 'Exporting',
    //   content: 'Content yet to be placed'
    // },
    // {
    //   name: 'Dashboard',
    //   content: 'Content yet to be placed'
    // },
    // {
    //   name: 'Profile',
    //   content: 'Content yet to be placed'
    // },
    // {
    //   name: 'Theme',
    //   content: 'Content yet to be placed'
    // },
    // {
    //   name: 'Account',
    //   content: 'Content yet to be placed'
    // }
  ]
  createActionListButton = { "v": "5.6.5", "fr": 60, "ip": 0, "op": 91, "w": 233, "h": 60, "nm": "button", "ddd": 0, "assets": [], "fonts": { "list": [{ "fName": "YuGothicUI-Semibold", "fFamily": "Yu Gothic UI", "fStyle": "Semibold", "ascent": 81.9990234375 }] }, "layers": [{ "ddd": 0, "ind": 1, "ty": 5, "nm": "   Create List", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [30.261, 35.79, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "t": { "d": { "k": [{ "s": { "s": 20.3595104217529, "f": "YuGothicUI-Semibold", "t": "      Create List", "j": 0, "tr": 0, "lh": 24.4314125061035, "ls": 2, "fc": [0.184, 0.2, 0.349] }, "t": 0 }] }, "p": {}, "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } }, "a": [] }, "ip": 0, "op": 14400, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "mask 2", "td": 1, "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [116.452, 30, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0, 0], "ix": 1 }, "s": { "a": 0, "k": [100.81, 100.81, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[-15.217, 0], [0, 0], [0, -15.217], [0, 0], [15.217, 0], [0, 0], [0, 15.217], [0, 0]], "o": [[0, 0], [15.217, 0], [0, 0], [0, 15.217], [0, 0], [-15.217, 0], [0, 0], [0, -15.217]], "v": [[-84.296, -27.553], [84.296, -27.553], [111.849, 0], [111.849, 0], [84.296, 27.553], [-84.296, 27.553], [-111.849, 0], [-111.849, 0]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "rect4520", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 14400, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 3, "ty": 4, "nm": "yellow", "tt": 1, "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 1, "k": [{ "i": { "x": 0.667, "y": 1 }, "o": { "x": 0.333, "y": 0 }, "t": 0, "s": [201.301, 139.78, 0], "to": [0, 0, 0], "ti": [0, 0, 0] }, { "t": 44, "s": [81.801, 63.78, 0] }], "ix": 2 }, "a": { "a": 0, "k": [0, 0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [-22.02, 0.72], [-31.2, 0], [-31.14, -1.08], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [31.2, -1.08], [31.14, 0], [22.08, 0.72], [0, 0], [0, 0], [0, 0]], "v": [[-159.87, -64.264], [-95.43, -79.264], [-3.09, -64.264], [89.19, -79.264], [153.69, -64.264], [159.87, 79.316], [-159.87, 79.316]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "fl", "c": { "a": 0, "k": [1, 0.721568627451, 0.298039215686, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 14400, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "mask", "td": 1, "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [116.452, 30, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0, 0], "ix": 1 }, "s": { "a": 0, "k": [99.887, 99.887, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[-15.217, 0], [0, 0], [0, -15.217], [0, 0], [15.217, 0], [0, 0], [0, 15.217], [0, 0]], "o": [[0, 0], [15.217, 0], [0, 0], [0, 15.217], [0, 0], [-15.217, 0], [0, 0], [0, -15.217]], "v": [[-84.296, -27.553], [84.296, -27.553], [111.849, 0], [111.849, 0], [84.296, 27.553], [-84.296, 27.553], [-111.849, 0], [-111.849, 0]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "rect4520", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 14400, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 5, "ty": 4, "nm": "blue", "tt": 1, "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 1, "k": [{ "i": { "x": 0.667, "y": 1 }, "o": { "x": 0.333, "y": 0 }, "t": 0, "s": [36.301, 139.28, 0], "to": [0, 0, 0], "ti": [0, 0, 0] }, { "t": 44, "s": [163.301, 65.28, 0] }], "ix": 2 }, "a": { "a": 0, "k": [0, 0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [-22.02, 0.72], [-31.2, 0], [-31.14, -1.08], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [31.2, -1.08], [31.14, 0], [22.08, 0.72], [0, 0], [0, 0], [0, 0]], "v": [[-159.87, -64.264], [-95.43, -79.264], [-3.09, -64.264], [89.19, -79.264], [153.69, -64.264], [159.87, 79.316], [-159.87, 79.316]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "fl", "c": { "a": 0, "k": [0.172549019608, 0.462745098039, 0.721568627451, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 14400, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 6, "ty": 4, "nm": "rect4520", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [116.452, 30, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[-15.217, 0], [0, 0], [0, -15.217], [0, 0], [15.217, 0], [0, 0], [0, 15.217], [0, 0]], "o": [[0, 0], [15.217, 0], [0, 0], [0, 15.217], [0, 0], [-15.217, 0], [0, 0], [0, -15.217]], "v": [[-84.296, -27.553], [84.296, -27.553], [111.849, 0], [111.849, 0], [84.296, 27.553], [-84.296, 27.553], [-111.849, 0], [-111.849, 0]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [1, 0.721568627451, 0.298039215686, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 3, "ix": 5 }, "lc": 2, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "rect4520", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 14400, "st": 0, "bm": 0 }], "markers": [], "chars": [{ "ch": "+", "size": 20.3595104217529, "style": "Semibold", "w": 69.43, "data": { "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "v": [[58.105, -32.959], [38.818, -32.959], [38.818, -52.295], [30.762, -52.295], [30.762, -32.959], [11.475, -32.959], [11.475, -24.902], [30.762, -24.902], [30.762, -5.615], [38.818, -5.615], [38.818, -24.902], [58.105, -24.902]], "c": true }, "ix": 2 }, "nm": "+", "mn": "ADBE Vector Shape - Group", "hd": false }], "nm": "+", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }] }, "fFamily": "Yu Gothic UI" }, { "ch": "C", "size": 20.3595104217529, "style": "Semibold", "w": 62.11, "data": { "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [6.608, 0], [4.395, 4.574], [0, 7.715], [-4.704, 4.851], [-7.585, 0], [-4.72, -2.799], [0, 0], [6.77, 0], [6.885, -6.901], [0, -11.198], [-6.12, -6.413], [-10.156, 0], [-5.273, 2.734]], "o": [[-4.851, 3.125], [-7.162, 0], [-4.395, -4.573], [0, -8.105], [4.704, -4.85], [5.696, 0], [0, 0], [-4.46, -1.92], [-10.515, 0], [-6.885, 6.902], [0, 10.417], [6.12, 6.413], [7.845, 0], [0, 0]], "v": [[57.471, -13.672], [40.283, -8.984], [22.949, -15.845], [16.357, -34.277], [23.413, -53.711], [41.846, -60.986], [57.471, -56.787], [57.471, -68.311], [40.625, -71.191], [14.526, -60.84], [4.199, -33.691], [13.379, -8.447], [37.793, 1.172], [57.471, -2.93]], "c": true }, "ix": 2 }, "nm": "C", "mn": "ADBE Vector Shape - Group", "hd": false }], "nm": "C", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }] }, "fFamily": "Yu Gothic UI" }, { "ch": "r", "size": 20.3595104217529, "style": "Semibold", "w": 37.01, "data": { "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [2.051, 0], [2.295, -1.969], [1.106, -3.516], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-2.246, 3.027], [-3.353, 0], [-1.367, -1.074]], "o": [[-1.074, -0.618], [-2.832, 0], [-2.295, 1.97], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -5.208], [2.246, -3.027], [2.571, 0], [0, 0]], "v": [[36.377, -49.951], [31.689, -50.879], [23.999, -47.925], [18.896, -39.697], [18.701, -39.697], [18.701, -50], [7.373, -50], [7.373, 0], [18.701, 0], [18.701, -23.926], [22.07, -36.279], [30.469, -40.82], [36.377, -39.209]], "c": true }, "ix": 2 }, "nm": "r", "mn": "ADBE Vector Shape - Group", "hd": false }], "nm": "r", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }] }, "fFamily": "Yu Gothic UI" }, { "ch": "e", "size": 20.3595104217529, "style": "Semibold", "w": 53.13, "data": { "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [3.743, 4.395], [6.836, 0], [4.606, -4.899], [0, -7.78], [-4.183, -4.541], [-7.357, 0], [-4.558, 2.865], [0, 0], [5.338, 0], [2.718, 2.507], [0.13, 4.623], [0, 0]], "o": [[0, -7.813], [-3.744, -4.395], [-6.836, 0], [-4.607, 4.9], [0, 8.236], [4.182, 4.541], [7.487, 0], [0, 0], [-4.46, 3.191], [-4.753, 0], [-2.718, -2.506], [0, 0], [0, 0]], "v": [[49.707, -26.27], [44.092, -44.58], [28.223, -51.172], [11.06, -43.823], [4.15, -24.805], [10.425, -5.64], [27.734, 1.172], [45.801, -3.125], [45.801, -12.256], [31.104, -7.471], [19.897, -11.23], [15.625, -21.924], [49.707, -21.924]], "c": true }, "ix": 2 }, "nm": "e", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ind": 1, "ty": "sh", "ix": 2, "ks": { "a": 0, "k": { "i": [[0, 0], [-2.263, 2.377], [-3.255, 0], [-1.888, -2.262], [-0.033, -4.069]], "o": [[0.52, -3.841], [2.262, -2.376], [3.32, 0], [1.888, 2.263], [0, 0]], "v": [[15.625, -29.932], [19.8, -39.258], [28.076, -42.822], [35.889, -39.429], [38.77, -29.932]], "c": true }, "ix": 2 }, "nm": "e", "mn": "ADBE Vector Shape - Group", "hd": false }], "nm": "e", "np": 5, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }] }, "fFamily": "Yu Gothic UI" }, { "ch": "a", "size": 20.3595104217529, "style": "Semibold", "w": 52.2, "data": { "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [12.63, 0], [5.273, -3.125], [0, 0], [-5.957, 0], [0, -7.129], [0, 0], [0, -9.44], [-2.783, -2.669], [-4.916, 0], [-3.451, 5.99], [0, 0], [0, 0], [0, 0]], "o": [[0, -12.434], [-6.902, 0], [0, 0], [4.785, -4.102], [6.77, 0], [0, 0], [-10.873, 1.563], [0, 4.395], [2.783, 2.67], [6.673, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "v": [[45.752, -32.52], [26.807, -51.172], [8.545, -46.484], [8.545, -36.572], [24.658, -42.725], [34.814, -32.031], [19.971, -29.932], [3.662, -13.428], [7.837, -2.832], [19.385, 1.172], [34.57, -7.813], [34.766, -7.813], [34.766, 0], [45.752, 0]], "c": true }, "ix": 2 }, "nm": "a", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ind": 1, "ty": "sh", "ix": 2, "ks": { "a": 0, "k": { "i": [[0, 0], [2.262, -2.425], [3.45, 0], [1.514, 1.351], [0, 2.116], [-1.644, 1.156], [-3.255, 0.423], [0, 0]], "o": [[0, 3.679], [-2.263, 2.425], [-2.539, 0], [-1.514, -1.35], [0, -2.897], [1.643, -1.155], [0, 0], [0, 0]], "v": [[34.814, -20.215], [31.421, -11.06], [22.852, -7.422], [16.772, -9.448], [14.502, -14.648], [16.968, -20.728], [24.316, -23.096], [34.814, -24.561]], "c": true }, "ix": 2 }, "nm": "a", "mn": "ADBE Vector Shape - Group", "hd": false }], "nm": "a", "np": 5, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }] }, "fFamily": "Yu Gothic UI" }, { "ch": "t", "size": 20.3595104217529, "style": "Semibold", "w": 36.13, "data": { "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [1.92, 0], [1.074, 1.27], [0, 2.962], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-9.701, 0], [-2.214, 1.106]], "o": [[-1.4, 1.107], [-2.507, 0], [-1.074, -1.27], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 9.31], [3.613, 0], [0, 0]], "v": [[33.74, -9.521], [28.76, -7.861], [23.389, -9.766], [21.777, -16.113], [21.777, -41.113], [33.74, -41.113], [33.74, -50], [21.777, -50], [21.777, -64.795], [10.449, -61.572], [10.449, -50], [2.1, -50], [2.1, -41.113], [10.449, -41.113], [10.449, -12.842], [25, 1.123], [33.74, -0.537]], "c": true }, "ix": 2 }, "nm": "t", "mn": "ADBE Vector Shape - Group", "hd": false }], "nm": "t", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }] }, "fFamily": "Yu Gothic UI" }, { "ch": " ", "size": 20.3595104217529, "style": "Semibold", "w": 27.49, "data": {}, "fFamily": "Yu Gothic UI" }, { "ch": "A", "size": 20.3595104217529, "style": "Semibold", "w": 67.14, "data": { "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "v": [[40.137, -70.02], [27.051, -70.02], [0.83, 0], [13.525, 0], [19.58, -17.822], [47.119, -17.822], [53.418, 0], [66.162, 0]], "c": true }, "ix": 2 }, "nm": "A", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ind": 1, "ty": "sh", "ix": 2, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [-0.293, 1.855], [0, 0], [-0.293, -0.911], [0, 0]], "o": [[0, 0], [0.358, -1.074], [0, 0], [0.325, 2.019], [0, 0], [0, 0]], "v": [[22.607, -27.295], [32.227, -55.225], [33.203, -59.619], [33.398, -59.619], [34.326, -55.225], [44.043, -27.295]], "c": true }, "ix": 2 }, "nm": "A", "mn": "ADBE Vector Shape - Group", "hd": false }], "nm": "A", "np": 5, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }] }, "fFamily": "Yu Gothic UI" }, { "ch": "c", "size": 20.3595104217529, "style": "Semibold", "w": 47.02, "data": { "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [4.069, 0], [2.881, 2.995], [0, 5.176], [-3.06, 3.239], [-4.785, 0], [-3.484, -2.604], [0, 0], [4.557, 0], [4.899, -4.996], [0, -8.235], [-4.558, -4.639], [-7.422, 0], [-4.004, 2.311]], "o": [[-3.613, 2.898], [-4.851, 0], [-2.881, -2.995], [0, -5.241], [3.059, -3.239], [3.938, 0], [0, 0], [-3.484, -1.595], [-8.203, 0], [-4.9, 4.997], [0, 7.39], [4.557, 4.639], [5.469, 0], [0, 0]], "v": [[43.164, -12.158], [31.641, -7.813], [20.044, -12.305], [15.723, -24.561], [20.313, -37.28], [32.08, -42.139], [43.213, -38.232], [43.213, -48.779], [31.152, -51.172], [11.499, -43.677], [4.15, -23.828], [10.986, -5.786], [28.955, 1.172], [43.164, -2.295]], "c": true }, "ix": 2 }, "nm": "c", "mn": "ADBE Vector Shape - Group", "hd": false }], "nm": "c", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }] }, "fFamily": "Yu Gothic UI" }, { "ch": "i", "size": 20.3595104217529, "style": "Semibold", "w": 26.12, "data": { "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[-1.335, 1.254], [0, 1.758], [1.334, 1.237], [1.92, 0], [1.318, -1.237], [0, -1.855], [-1.318, -1.204], [-1.855, 0]], "o": [[1.334, -1.253], [0, -1.855], [-1.335, -1.237], [-1.855, 0], [-1.318, 1.237], [0, 1.855], [1.318, 1.205], [1.92, 0]], "v": [[17.969, -62.378], [19.971, -66.895], [17.969, -71.533], [13.086, -73.389], [8.325, -71.533], [6.348, -66.895], [8.325, -62.305], [13.086, -60.498]], "c": true }, "ix": 2 }, "nm": "i", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ind": 1, "ty": "sh", "ix": 2, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0]], "v": [[18.701, -50], [7.373, -50], [7.373, 0], [18.701, 0]], "c": true }, "ix": 2 }, "nm": "i", "mn": "ADBE Vector Shape - Group", "hd": false }], "nm": "i", "np": 5, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }] }, "fFamily": "Yu Gothic UI" }, { "ch": "o", "size": 20.3595104217529, "style": "Semibold", "w": 59.72, "data": { "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[-4.704, 4.802], [0, 7.976], [4.362, 4.59], [7.813, 0], [4.801, -4.72], [0, -8.398], [-4.607, -4.671], [-7.715, 0]], "o": [[4.704, -4.801], [0, -8.138], [-4.362, -4.59], [-8.138, 0], [-4.802, 4.72], [0, 7.715], [4.606, 4.671], [7.942, 0]], "v": [[48.511, -6.03], [55.566, -25.195], [49.023, -44.287], [30.762, -51.172], [11.353, -44.092], [4.15, -24.414], [11.06, -5.835], [29.541, 1.172]], "c": true }, "ix": 2 }, "nm": "o", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ind": 1, "ty": "sh", "ix": 2, "ks": { "a": 0, "k": { "i": [[-2.393, -2.995], [0, -5.501], [2.393, -2.962], [4.459, 0], [2.604, 3.011], [0, 5.241], [-2.572, 3.093], [-4.427, 0]], "o": [[2.393, 2.995], [0, 5.469], [-2.393, 2.962], [-4.362, 0], [-2.605, -3.011], [0, -5.436], [2.571, -3.092], [4.459, 0]], "v": [[40.356, -37.646], [43.945, -24.902], [40.356, -12.256], [30.078, -7.813], [19.629, -12.329], [15.723, -24.707], [19.58, -37.5], [30.078, -42.139]], "c": true }, "ix": 2 }, "nm": "o", "mn": "ADBE Vector Shape - Group", "hd": false }], "nm": "o", "np": 5, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }] }, "fFamily": "Yu Gothic UI" }, { "ch": "n", "size": 20.3595104217529, "style": "Semibold", "w": 58.35, "data": { "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [2.864, 3.532], [5.436, 0], [3.743, -6.315], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-2.246, 2.588], [-3.451, 0], [0, -9.342], [0, 0], [0, 0]], "o": [[0, -6.673], [-2.865, -3.532], [-7.064, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -3.938], [2.246, -2.588], [6.608, 0], [0, 0], [0, 0], [0, 0]], "v": [[51.904, -30.566], [47.607, -45.874], [35.156, -51.172], [18.945, -41.699], [18.75, -41.699], [18.75, -50], [7.373, -50], [7.373, 0], [18.75, 0], [18.75, -28.516], [22.119, -38.306], [30.664, -42.188], [40.576, -28.174], [40.576, 0], [51.904, 0]], "c": true }, "ix": 2 }, "nm": "n", "mn": "ADBE Vector Shape - Group", "hd": false }], "nm": "n", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }] }, "fFamily": "Yu Gothic UI" }, { "ch": "L", "size": 20.3595104217529, "style": "Semibold", "w": 48.88, "data": { "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "v": [[47.412, -9.814], [20.264, -9.814], [20.264, -70.02], [8.643, -70.02], [8.643, 0], [47.412, 0]], "c": true }, "ix": 2 }, "nm": "L", "mn": "ADBE Vector Shape - Group", "hd": false }], "nm": "L", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }] }, "fFamily": "Yu Gothic UI" }, { "ch": "s", "size": 20.3595104217529, "style": "Semibold", "w": 43.12, "data": { "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[-5.469, 0], [-2.556, 0.602], [-1.953, 1.237], [-1.172, 1.888], [0, 2.539], [0.651, 1.514], [1.204, 1.156], [1.709, 0.912], [2.148, 0.879], [1.253, 0.472], [0.895, 0.57], [0.455, 0.749], [0, 1.074], [-0.456, 0.732], [-0.814, 0.521], [-1.156, 0.293], [-1.433, 0], [-3.516, -2.409], [0, 0], [4.622, 0], [2.441, -0.635], [1.92, -1.253], [1.139, -1.839], [0, -2.409], [-0.554, -1.465], [-1.091, -1.155], [-1.644, -0.911], [-2.051, -0.813], [-1.351, -0.488], [-0.993, -0.618], [-0.586, -0.797], [0, -1.139], [6.836, 0], [4.231, 3.223], [0, 0]], "o": [[2.832, 0], [2.555, -0.602], [1.953, -1.237], [1.172, -1.888], [0, -2.083], [-0.652, -1.514], [-1.205, -1.155], [-1.709, -0.911], [-1.628, -0.553], [-1.254, -0.471], [-0.896, -0.569], [-0.456, -0.748], [0, -0.879], [0.455, -0.732], [0.813, -0.52], [1.155, -0.293], [4.557, 0], [0, 0], [-3.646, -1.399], [-2.605, 0], [-2.441, 0.635], [-1.921, 1.254], [-1.14, 1.839], [0, 1.953], [0.553, 1.465], [1.09, 1.156], [1.643, 0.912], [1.66, 0.619], [1.35, 0.488], [0.993, 0.619], [0.586, 0.798], [0, 4.037], [-5.111, 0], [0, 0], [4.004, 1.823]], "v": [[18.457, 1.172], [26.538, 0.269], [33.301, -2.49], [37.988, -7.178], [39.746, -13.818], [38.77, -19.214], [35.986, -23.218], [31.616, -26.318], [25.83, -29.004], [21.509, -30.542], [18.286, -32.104], [16.26, -34.082], [15.576, -36.816], [16.26, -39.233], [18.164, -41.113], [21.118, -42.334], [25, -42.773], [37.109, -39.16], [37.109, -49.072], [24.707, -51.172], [17.139, -50.22], [10.596, -47.388], [6.006, -42.749], [4.297, -36.377], [5.127, -31.25], [7.593, -27.319], [11.694, -24.219], [17.236, -21.631], [21.753, -19.971], [25.269, -18.311], [27.637, -16.187], [28.516, -13.281], [18.262, -7.227], [4.248, -12.061], [4.248, -1.563]], "c": true }, "ix": 2 }, "nm": "s", "mn": "ADBE Vector Shape - Group", "hd": false }], "nm": "s", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }] }, "fFamily": "Yu Gothic UI" }] }
  organizations = [];
  constructor(
    public dialog: MatDialog,
    private _activatedRoute: ActivatedRoute,
    private _cookieService: CookieService,
    private _router: Router,
    private _loaderService: LoaderService,
    private _changeDetectionRef: ChangeDetectorRef,
    private _s3Service: S3Service,
    private _formService: FormService,
    public _sharedService: SharedService,
    private _dashboardService: DashboardService,
    private _profileService: ProfileService,
    private _filecabinetService: FileCabinetFormsService
  ) {
    this._loaderService.loadingChange.subscribe(value => {
      this.isLoading = value;
    });

    const organizations = localStorage.getItem('organizations');
    const organizagionCode = localStorage.getItem('organizationCode');

    if (organizagionCode) {
      this.organizagionCode = organizagionCode
    }

    this.organizations = organizations ? JSON.parse(organizations) : [];
    this.organizations = _.filter(this.organizations, (org) => {
      return org.team_status == true
    })

    this._dashboardService.appendBgClr.subscribe((theme) => {
      if (theme) {
        localStorage.setItem('bgColor', theme.background)
        this.bgColor = theme.background;
        localStorage.setItem('bgTextColor', theme.text)
        this.bgTextColor = theme.text;
        document.body.style.background = this.bgColor;
      }
    });

    let logoKey;
    this._sharedService.getUserDetails().subscribe((response) => {
      if (response["success"] && this._cookieService.get("super_admin") != 'true') {
        localStorage.setItem('enable_subscription', response['enable_subscription'] || false);
        localStorage.setItem('email', response['user']['email']);
        localStorage.setItem('organization', response['user']['organization']);
        localStorage.setItem('role', response['user']['role']);
        localStorage.setItem('username', response['user']['username']);
        localStorage.setItem('firstName', response['user']['firstName']);
        localStorage.setItem('lastName', response['user']['lastName']);
        localStorage.setItem('organizationLogo', response['user']['organizationLogo']);
        if (response['user']['address'] && response['user']['address']['state']) {
          localStorage.setItem('organizationAddress', response['user']['address']['state']);
        }
        localStorage.setItem('organizationName', response['user']['organizationName']);
        localStorage.setItem('organizationCode', response['user']['organizationCode']);
        localStorage.setItem('userId', response['user']['userId']);
        localStorage.setItem('tooltip_enabled', response['user']['tooltip_enabled'])

        this.userName = this.userNameToUpperCase(localStorage.getItem('firstName') + " " + localStorage.getItem('lastName'));
        this.organizationName = localStorage.getItem('organizationName');
        this.location = localStorage.getItem('organizationAddress');
        logoKey = localStorage.getItem('organizationLogo');

        if (response['user'] && response['user']['tooltip_enabled'] == undefined) {
          localStorage.setItem('tooltip_enabled', 'true')
        }

        if (response['user']['theme'] && response['user']['theme']['bg_color']) localStorage.setItem('bgColor', response['user']['theme']['bg_color']);
        if (response['user']['theme'] && response['user']['theme']['bg_text_color']) localStorage.setItem('bgTextColor', response['user']['theme']['bg_text_color']);

        // Adding timezone to localstorage
        if (response['user'] && response['user']['timezone']) {
          localStorage.setItem('timezone', response['user']['timezone']);
          moment.tz.setDefault(response['user']['timezone'])
        } else {
          localStorage.removeItem('timezone');
          moment.tz.setDefault(moment.tz.guess())
        }

        this.organizations = _.filter(response['user']['organizations'], (org) => {
          return org.team_status == true
        })

        if (logoKey && logoKey.length > 0) {
          // Fetch organization image data from server
          this.fetchFileFromS3(logoKey);
        }
      }
    })

    this._profileService.organizationDataUpdate.subscribe((value) => {
      this.userName = this.userNameToUpperCase(localStorage.getItem('firstName') + " " + localStorage.getItem('lastName'));
      this.organizationName = localStorage.getItem('organizationName');
      this.location = localStorage.getItem('organizationAddress');
      let logoKey = localStorage.getItem('organizationLogo');
      if (value) {
        this.organizations = _.filter(value['organizations'], (org) => {
          return org.team_status == true
        })
        this.organizagionCode = value['code'];
      }
      if (logoKey && logoKey.length > 0) {
        // Fetch organization image data from server
        this.fetchFileFromS3(logoKey);
      }
    });

    this._dashboardService.sharedCount.subscribe((value) => {
      this.ngOnInit();
    });

    this._dashboardService.updateHeaderCounts.subscribe(() => {
      this.ngOnInit();
    })



    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this._activatedRoute.snapshot.firstChild)
          this.currentPage = this._activatedRoute.snapshot.firstChild.routeConfig.path;
        if (this._activatedRoute.snapshot.firstChild.params.actionType) this.childMenu = this._activatedRoute.snapshot.firstChild.params.actionType;
        else if (this._activatedRoute.snapshot.firstChild.params.id) this.childMenu = this._activatedRoute.snapshot.firstChild.params.id;
        else this.childMenu = "";
      }
    });
    if (localStorage.getItem('bgColor')) this.bgColor = localStorage.getItem('bgColor');
    // Get user privelges
    this._sharedService.getPrivileges(localStorage.getItem('role')).subscribe((response) => {
      if (response['success']) {
        this.userPriveleges = response['data'][0]['privileges'];
      }
    });
  }

  ngAfterContentChecked() {
    this._changeDetectionRef.detectChanges();
    let body = document.getElementsByTagName('body')[0];
    body.style.backgroundColor = this.bgColor;
  }

  openDialog(): void {

    const player = document.querySelector('lottie-player');
    player["play"]();
    const dialogRef = this.dialog.open(CreateActionList, {
      width: '520px',
      data: { name: this.name, animal: this.animal },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      player["stop"]();
      if (result && result["response"]) {
        this.ngOnInit();
      }
    });
  }


  ngOnInit(): void {

    this._sharedService.getAppConfig().subscribe((response: any) => {
      if (response['success']) {
        this.tutorialVideosUrl = response['data']['tutorial_videos_url'];
      }
    });

    this._sharedService.getDefaultActionTypes(localStorage.getItem('organization')).subscribe((response) => {
      if (response["success"]) {
        // if (response["data"] && response["data"].length > 0) {
          this.defaultActionTypes = response["data"];
        // }
      }
    });

    this._formService.getActionTypes(localStorage.getItem('organization')).subscribe((response) => {
      if (response['success']) {
        // if (response['data'] && response['data'].length > 0) {
          this.actionTypes = response['data'];
          this.actionTypes.forEach((element) => {
            element["count"] = 0;
          });
          this.subMenu = _.map(this.actionTypes, (item) => { return item._id });
        // }
      }
    }, (error) => {
      console.log(error);
    });

    // if (logoKey && logoKey.length > 0) {
    //   // Fetch organization image data from server
    //   this.fetchFileFromS3(logoKey);
    // }

    // // Get action types forms count
    // this._dashboardService.getSubmittedForms(localStorage.getItem("organization")).subscribe((response) => {
    //   if (response['success']) {
    //     if (response['data'].length > 0) {
    //       let actionTypesCount = [];
    //       let data = response["data"];
    //       data.forEach((form) => {
    //         let actionTypes = form["actionTypes"];
    //         if (actionTypes && actionTypes.length > 0) {
    //           actionTypes.forEach((actionType) => {
    //             actionTypesCount.push(actionType);
    //           });
    //         }
    //       });

    //       actionTypesCount.forEach((id) => {
    //         this.actionTypes.forEach((actionType) => {
    //           if (actionType._id === id) {
    //             actionType.count += 1;
    //           }
    //         });
    //       });
    //     }
    //   }
    // });
  }


  checkPrivilege(accessType) {
    return this._sharedService.checkPrivilege(this.userPriveleges, accessType);
  }

  fetchFileFromS3(key) {
    // this.isLoading = true;
    if (key.length > 0) {
      this._s3Service.getObjectFromKey(key).subscribe((response) => {
        if (response && Object.keys(response["data"]).length > 0) {
          var binary = '';
          var bytes = new Uint16Array(response['data']);
          var len = bytes.byteLength;
          for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          this.organizationLogo = window.btoa(binary);
          this.organizationLogo = "data:image/jpeg;base64," + this.organizationLogo;
          // this.isLoading = false;
        }
      }, (error) => {
        console.log(error);
        // this.isLoading = false;
      });
    }
  }

  userNameToUpperCase(text) {
    return text.toLowerCase().split(' ').map((i, j) => i.charAt(0).toUpperCase() + i.slice(1)).join(' ');
  }


  changePassword() {
    this.dialog.open(ChangePasswordComponent, {
    });
  }
  logout(): void {
    // Logout confirmation
    const dialogRef = this.dialog.open(LogoutConfirmationComponent, {
      width: '500px',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        window['_app_base'] = "";
        localStorage.clear();
        let url = window.location.href;
        let domain = new URL(url).hostname;
        this._cookieService.delete('x-header-authToken', "/", domain);
        this._cookieService.delete('isLoggedIn', "/", domain);
        this._cookieService.deleteAll('/', domain);
        const loginUrl = this._router.serializeUrl(this._router.createUrlTree(['login']));
        window.open(loginUrl, '_self');
        let body = document.getElementsByTagName('body')[0];
        body.style.backgroundColor = '#F9FAFE';
      } else {
        return;
      }
    });
  }

  divEntered(actionType, event): void {
    this.draggingOn = actionType.name
    this.hoverHighlight = true;
    this.selectedActionType = actionType.name;
    if (this.currentPage == "file-cabinet") {
      document.getElementById("storage-actiontype").style.pointerEvents = "none";
    }
    event.preventDefault();
  }

  divLeft(actionType, event, dropped, from?): void {
    this.draggingOn = ""
    this.hoverHighlight = false;
    this.selectedActionType = "";
    this.childMenu = "";
    event.preventDefault();
    let forms = JSON.parse(event.dataTransfer.types[0]);
    if (this.currentPage == "file-cabinet") {
      document.getElementById("storage-actiontype").style.pointerEvents = "auto";
    }
    if (dropped) {
      let requestData = {
        ids: JSON.parse(event.dataTransfer.types[0]),
        actionType: actionType._id
      }
      if (this.currentPage == "file-cabinet") {
        requestData['isFromStorage'] = true;
        requestData['actionListId'] = localStorage.getItem("defaultAction");
      }
      this._formService.addActionTypeToForms(requestData).subscribe((response) => {
        if (response['success']) {
          let msg = from && from == "default" ? "Moving Submission(s)" : "Copying Submission(s)"
          this._sharedService.openSnackBar(msg);
          this._dashboardService.sendResetSelectedFormsEvent();
          this.ngOnInit();
          if (this.currentPage == "file-cabinet") {
            this._filecabinetService.updateFileCabinetForms(forms)
          } else {
            this._dashboardService.refreshFormsList(forms);
          }
        }
      }, (error) => {
        this._sharedService.openSnackBar('Server side error occurred');
        console.log(error);
      });
    }
  }

  dropBackBurner(actionType, event, dropped, from?): void {
    this.draggingOn = ""
    this.selectedActionType = "";
    this.childMenu = "";
    event.preventDefault();
    let forms = JSON.parse(event.dataTransfer.types[0]);

    if (dropped) {
      this._formService.addActionTypeToForms({ ids: JSON.parse(event.dataTransfer.types[0]), actionType: actionType._id }).subscribe((response) => {
        if (response['success']) {
          this._sharedService.openSnackBar('Moving Submission(s)');
          this._dashboardService.sendResetSelectedFormsEvent();
          this.ngOnInit();
          this._dashboardService.refreshFormsList(forms);
        }
      }, (error) => {
        this._sharedService.openSnackBar('Server side error occurred');
        console.log(error);
      });
    }
  }

  onActionTypeChange(actionType, id, type?) {
    localStorage.setItem('actionType', actionType.name);
    if (type && type == "default") {
      localStorage.setItem('defaultAction', id)
      this._router.navigateByUrl('/file-cabinet')
    } else {
      this._router.navigateByUrl('/dashboard/' + id);
    }
  }

  onSearch(event) {
    this._sharedService.changeSearchText(event.target.value);
  }

  openSettings(): void {
    let urlEndPoint = "";
    let orgid = localStorage.getItem("organizationCode");
    if (this.checkPrivilege('profile')) {
      urlEndPoint = orgid + '/profile';
    } else if (this.checkPrivilege('theme')) {
      urlEndPoint = orgid + '/theme';
    } else if (this.checkPrivilege('forms')) {
      urlEndPoint = orgid + '/sort-forms';
    } else if (this.checkPrivilege('account')) {
      urlEndPoint = orgid + '/account';
    } else if (this.checkPrivilege('subscription')) {
      urlEndPoint = orgid + 'subscription';
    } else if (this.checkPrivilege('help')) {
      urlEndPoint = orgid + '/help';
    } else {
      urlEndPoint = orgid + '/tutorial';
    }
    const url = this._router.serializeUrl(this._router.createUrlTree([urlEndPoint]));

    if (this.windowSettingsRef == null || this.windowSettingsRef.closed) {
      this.windowSettingsRef = window.open(url, 'sort-settings');
    } else {
      this.windowSettingsRef.focus();
    };
  }

  openTutorialVideos(): void {
    window.open(this.tutorialVideosUrl, '_blank');
  }

  navigateToHelpItems(item) {
    let orgid = localStorage.getItem("organizationCode");
    let urlEndPoint = orgid + '/sort-forms';

    let url;
    switch (item) {
      case "CONTACT US":
        urlEndPoint = orgid + '/help';
        break;
      case "TUTORIAL VIDEOS":
        window.open(this.tutorialVideosUrl, '_blank');
        return;
      default:
        break;
    }
    url = this._router.serializeUrl(this._router.createUrlTree([urlEndPoint]));
    this.windowSettingsRef = window.open(url, 'sort-settings');
  }

  openHelpForm() {
    let orgid = localStorage.getItem("organizationCode");
    let urlEndPoint = orgid + '/sort-forms';
    if (this.checkPrivilege('help')) {
      urlEndPoint = orgid + '/help';
    }
    const url = this._router.serializeUrl(this._router.createUrlTree([urlEndPoint]));

    if (this.windowSettingsRef == null || this.windowSettingsRef.closed) {
      this.windowSettingsRef = window.open(url, 'sort-settings');
    } else {
      this.windowSettingsRef.focus();
    };
  }

  openHelpFaq() {
    let urlEndPoint = "";
    let orgid = localStorage.getItem("organizationCode");
    urlEndPoint = orgid + '/help-faq';

    if (this.windowHelpFaqRef == null || this.windowHelpFaqRef.closed) {
      this.windowHelpFaqRef = window.open(urlEndPoint)
    } else {
      this.windowHelpFaqRef.focus()
    }
    window.open
  }

  openHome(): void {
    let url = ""
    url = this._router.serializeUrl(this._router.createUrlTree([localStorage.getItem('organizationCode') + '/dashboard']));

    if (this.checkPrivilege('super_user') && !this.checkPrivilege('dashboard')) {
      url = this._router.serializeUrl(this._router.createUrlTree([localStorage.getItem('organizationCode') + '/organizations']));
    }

    if (this.windowHomeRef == null || this.windowHomeRef.closed) {
      this.windowHomeRef = window.open(url, 'sort-home');
    } else {
      this.windowHomeRef.focus();
    };
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.actionTypes, event.previousIndex, event.currentIndex);
      let actionLists = [];
      let order = 0;
      this.actionTypes.forEach((actionType) => {
        let obj = {
          actionTypeId: actionType._id,
          order: order
        };
        actionLists.push(obj);
        order = order + 1;
      })
      let requestData = {
        actionLists: actionLists
      };

      this._sharedService.updateActionListOrder(requestData).subscribe((response) => {
        if (response["success"]) {
          this._dashboardService.refreshCount([]);
        }
      }, (error) => {
        console.log(error);
      });
    }
  }

  // onHoveringLogo() {
  //   let logo = document.getElementById('logo');
  //   logo.setAttribute('src', '../../assets/images/SORT_Logo.gif');
  //   logo.className = "logo-gif";
  // }

  onHoveringLogo() {
    this.logoSource = '../../assets/images/SORT_Logo.gif'
    setTimeout(() => {
      this.logoSource = '../../assets/images/sort-logo.svg'
    }, 5000)
  }

  onMouseOutLogo() {
    this.logoSource = '../../assets/images/sort-logo.svg'
    // let logo = document.getElementById('logo');
    // logo.setAttribute('src', '../../assets/images/sort-logo.svg');
    // logo.className = "logo-image";
  }

  checkWhatisDragging() {
    if (this.defaultActionTypes[0].name == this.draggingOn) {
      if (this.currentPage != "file-cabinet") {
        return true;
      } else {
        return false;
      }
    }
    return false
  }

  // Drag and drop on completed and trash
  divEnteredOn(val, event) {
    if (val == 'completed') {
      this.draggingOnCompleted = true
    } else if (val == 'trash') {
      this.draggingOnTrash = true
    } else {
      this.draggingOnCompleted = false;
      this.draggingOnTrash = false;
    }
    event.preventDefault()
  }

  divLeftOn(val, event) {
    if (val == 'completed') {
      this.draggingOnCompleted = false
    } else if (val == 'trash') {
      this.draggingOnTrash = false
    } else {
      this.draggingOnCompleted = false;
      this.draggingOnTrash = false;
    }
    event.preventDefault()

  }

  droppedOn(val, event) {
    if (val == 'completed') {
      this.draggingOnCompleted = false
      let forms = JSON.parse(event.dataTransfer.types[0]);
      let requestData = {
        formIds: forms
      }
      event.preventDefault()
      this._formService.archiveForms(requestData).subscribe((response) => {
        if (response['success']) {
          this._sharedService.openSnackBar('Archived Submission(s) successfully');
          this.ngOnInit();
          if (this.currentPage == "file-cabinet") {
            this._filecabinetService.updateFileCabinetForms(forms)
          } else {
            this._dashboardService.refreshFormsList(forms);
          }
        }
      }, (error) => {
        this._sharedService.openSnackBar('Server side error occurred');
        console.log(error);
      })
    } else if (val == 'trash') {
      this.draggingOnTrash = false
      let forms = JSON.parse(event.dataTransfer.types[0]);
      console.log("DIV DROPPED", val, forms)
      let requestData = {
        formIds: forms
      }
      event.preventDefault()
      this._formService.deleteForms(requestData).subscribe((response) => {
        if (response['success']) {
          this._sharedService.openSnackBar('Deleted Submission(s) Successfully');
          this.ngOnInit();
          if (this.currentPage == "file-cabinet") {
            this._filecabinetService.updateFileCabinetForms(forms)
          } else {
            this._dashboardService.refreshFormsList(forms);
          }
        }
      }, (error) => {
        this._sharedService.openSnackBar('Server side error occurred');
        console.log(error);
      })
    } else {
      this.draggingOnCompleted = false;
      this.draggingOnTrash = false;
    }

  }

  getUserDetails() {
    return new Promise((resolve, reject) => {
      try {
        return this._sharedService.getUserDetails().subscribe()
      } catch (error) {
        reject(error)
      }
    })
  }

  onClickingCopy(platform: any) {
    window.navigator.clipboard.writeText(platform.content).then(() => {
      this._sharedService.openSnackBar("Copied to clipboard.");
    })
  }
}



@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'create-action-list.html',
})
export class CreateActionList {

  constructor(
    public dialogRef: MatDialogRef<CreateActionList>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _formService: FormService,
    private _snackBar: MatSnackBar,
    private _dashboardService: DashboardService,
    private _router: Router) { }

  actionTypeName = "";
  error = "";

  onActionTypeChange(actionType) {
    this.actionTypeName = actionType;
    localStorage.setItem('actionType', this.actionTypeName);
  }

  onNoClick(): void {
    this.dialogRef.close({ result: false });
  }

  addActionType(): void {
    this.error = "";
    if (!_.isEmpty(this.actionTypeName)) {
      this._formService.createActionType({
        organization: localStorage.getItem('organization'), name: this.actionTypeName,
        created_by: {
          username: localStorage.getItem('username'),
          user_id: localStorage.getItem('userId'),
          organization_id: localStorage.getItem('organization')
        }
      }).subscribe((response) => {
        if (response['success']) {
          this._dashboardService.refreshCount([]);
          this.dialogRef.close({ result: true });
        } else {
          this.openSnackBar(response["message"]);
        }
      }, (error) => {
        console.log(error);
      });
    } else {
      this.openSnackBar("List name cannot be left empty");
    }
  }

  openSnackBar(message) {
    this._snackBar.open(message, "Ok", {
      duration: 2000
    });
  }
}
